<template>
  <div>
    <v-autocomplete
      :value="value"
      @input="handleInput"
      :items="countries_list"
      :loading="isLoadingCountries"
      :search-input.sync="searchCountries"
      @focus="() => onLoadCountries()"
      :rules="rules"
      placeholder="Search"
      item-text="name"
      item-value="code"
      :label="label"
      :required="required"
    ></v-autocomplete>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";
import { LOAD_COUNTRIES } from "@/store/modules/offers/types";
import { requestStatus } from "@/services/services";

export default {
  name: "CountriesSelect",
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "Country *",
    },
    required: {
      type: Boolean,
      default: true,
    },
    onChange: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      searchCountries: "",
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.offers.status,
      countries_list: (state) => state.offers.countries,
    }),
    isLoadingCountries() {
      return this.status.load_countries === requestStatus.loading;
    },
  },
  methods: {
    ...mapActions({
      onLoadCountries: `offers/${LOAD_COUNTRIES}`,
    }),
    onWaitChangeCountries() {
      if (
        this.searchCountries &&
        (this.searchCountries.length >= 2 || this.searchCountries === "")
      ) {
        this.onLoadCountries(`search=${this.searchCountries}`);
      }
    },
    handleInput(value) {
      this.$emit('input', value);
      if (this.onChange && typeof this.onChange === 'function') {
        this.onChange(value);
      }
    },
  },
  watch: {
    searchCountries() {
      this.onWaitChangeCountries();
    },
    value(newValue, oldValue) {
      if (!oldValue) {
        this.onLoadCountries(`search=${newValue ? newValue : ""}`);
      }
    },
  },
  created() {
    // this.onWaitChangeCountries = _.debounce(this.onWaitChangeCountries, 500);
    // if (!this.value) {
    //   this.onLoadCountries();
    // }
  },
};
</script>
